var ls_exists;
try {
    ls_exists = 'localStorage' in window && window['localStorage'] !== null;

    // try to actually save something to localStorage
    // it doesn't work in iOS Safari private or Chrome incognito
    var testKey = 'wafer-test';
    var testValue = 'wafer-test-value';
    window.localStorage.setItem(testKey, testValue);
    if (window.localStorage.getItem(testKey) !== testValue) {
        ls_exists = false;
    }
    window.localStorage.removeItem(testKey);
} catch (e) {
    // e can be SecurityError: DOM EXception 18
    ls_exists = false;
}
if(!ls_exists) {
    var _localstorage = {
        setItem: function(key, value, _e) {
            var l = _e === true ? -1 : 30,
                n = new Date();
            n.setDate(n.getDate() + l);
            document.cookie = key + "=" + escape(value) + '; expires=' + n.toUTCString();
        },
        getItem: function(key) {
            if(document.cookie.indexOf(key + '=') !== -1) {
                return unescape(document.cookie.split(key + '=')[1].split(';')[0].replace('=', ''));
            } else {
                return false;
            }
        },
        removeItem: function(key) {
            this.setItem(key, '', true);
        }
    };
}
var wafer = {
    _s: ls_exists ? window.localStorage : _localstorage,
    get: function(key) {
        var d = this._s.getItem(key);
        try {
            return JSON.parse(d);
        } catch(e) {
            return d;
        }
    },
    set: function(key, value) {
        try {
            JSON.parse(value);
        } catch(e) {
            value = JSON.stringify(value);
        }

        try {
            return this._s.setItem(key, value);
        } catch (e) {
            return false;
        }
    },
    remove: function(key) {
        return this._s.removeItem(key);
    }
};

module.exports = wafer;
